type WithKey<T, K extends keyof T> = T & Record<K, string | number>;
type Flatten<T> = T extends (infer U)[] ? U : T;

export function atArray<T>(data: Array<T>, index: number): T | undefined {
  return data.length - 1 >= index ? data[index] : undefined;
}

export function removeIfExists<T>(data: Array<T>, element: T): Array<T> {
  const index = data.indexOf(element);
  if (index > -1) {
    data.splice(index, 1);
  }
  return data;
}

export function clampArray<T>(array: T[], maxLength: number): T[] {
  return array.length > maxLength ? array.slice(0, maxLength) : array;
}

export function arrayPushUnique<T, K extends keyof T>(
  array: T[],
  itemsOrItem: WithKey<T, K> | WithKey<T, K>[],
  key: K
): void {
  const items = Array.isArray(itemsOrItem) ? itemsOrItem : [itemsOrItem];

  items.forEach(item => {
    const exists = array.some(existingItem => existingItem[key] === item[key]);
    if (!exists) {
      array.push(item);
    }
  });
}

export function getUniquePropertyValues<T, K extends keyof T>(
  items: T[],
  property: K
): Array<Flatten<T[K]>> {
  const uniqueValues = new Set<Flatten<T[K]>>();

  items.forEach((item) => {
    const value = item[property];
    if (Array.isArray(value)) {
      value.forEach((v) => uniqueValues.add(v as Flatten<T[K]>));
    } else if (value !== undefined && value !== null) {
      uniqueValues.add(value as Flatten<T[K]>);
    }
  });

  return Array.from(uniqueValues);
}